import getTableConversationRelation from 'mini-mail-list-store/lib/utils/getTableConversationRelation';
import getTableItemRelation from 'mini-mail-list-store/lib/utils/getTableItemRelation';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import TableViewConversationRelation from 'mini-mail-list-store/lib/store/schema/TableViewConversationRelation';
import TableViewItemRelation from 'mini-mail-list-store/lib/store/schema/TableViewItemRelation';
import { MailListRowDataType } from 'mini-mail-list-store/lib/store/schema/MailListRowDataType';

export default function findIndexByInstanceKey(
    row: MailListRowDataType,
    tableView: TableView
): number {
    const itemIds: string[] = tableView.itemIds;
    for (let index = 0; index < itemIds.length; index++) {
        const tableRowRelation = getTableRowRelation({
            itemId: itemIds[index],
            tableviewId: tableView.id,
            listViewType: tableView.tableQuery.listViewType,
        });

        if (tableRowRelation.instanceKey === row.InstanceKey) {
            return index;
        }
    }

    return -1;
}

function getTableRowRelation({
    itemId,
    tableviewId,
    listViewType,
}: {
    itemId: string;
    tableviewId: string;
    listViewType: ReactListViewType;
}): TableViewItemRelation | TableViewConversationRelation {
    switch (listViewType) {
        case ReactListViewType.Message:
            return getTableItemRelation(itemId, tableviewId);
        default:
            return getTableConversationRelation(itemId, tableviewId);
    }
}
